__turbopack_context__.v({
  "pictogram": "StepHeader-module__7IZlEW__pictogram",
  "root": "StepHeader-module__7IZlEW__root",
  "textWrapper": "StepHeader-module__7IZlEW__textWrapper",
});
